/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABZklEQVR4nN2VvUoDQRCA06ugKBaCdd5Cq1S5+YlwzpxEfARBRDHBUnwKrbQJgu/gYasvooJWaqEyd9FE7/Z+I4IDU+zuzHw7M/vTaPwrIZJlZLkA1idkfS+jsY9cIvpNZ3AgvS8bGBMqDxYrAbCd1w+usZIOEoAqZUF3Fo8pGUwquEaaCQDWg1arOwUkvQLNTbXNBPi+Px3NIc7kAVy22RmQ9MwRWfq5GThs/7YHODoNfc8LFoDlNll7uYnWSA4rAzySXVuLIXpql8guI5CcMG/OD+/PNpDuIepSu70xZ2NkfS4EAJJXjwJuOARY1pBlJ22+TA/egPQMcX2FaGvW1ONgFVjPbc12HgfVayQJXZup1GQgufvpXxsApC+fNU/znwBA9rP8nYDCjx2O1TzPdrwn0WdRANDpdBcje5IwN1vWqxEA/aad8wI9OK5Uoq8vk3Rg73nWsUXWo0qAOvL7AJLwW82H8gEoEI6Ng7z+jQAAAABJRU5ErkJggg==)
 */
export const StickerPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M21.6 13.54c.05.1.4.05.4-.07V6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4 11299.06 11299.06 0 0 0 7.76 0c.12 0 .17-.3.06-.36-1-.5-1.82-1.44-1.82-2.64a3 3 0 0 1 3-3h.5a.5.5 0 0 0 .5-.5V15a3 3 0 0 1 3-3c1.17 0 2.08.6 2.6 1.54ZM6.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-9.91 2.94a1 1 0 0 0-1.66 1.12 5.5 5.5 0 0 0 9.14 0 1 1 0 0 0-1.66-1.12 3.5 3.5 0 0 1-5.82 0Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
